export const articles = [
  {
    slug: 'niu-nai-ying-yang-zhi-shi',
    title: '每天喝牛奶的好处：营养师告诉你科学饮奶指南',
    excerpt: '牛奶被誉为"白色血液"，富含优质蛋白、钙质和多种维生素。本文将为您详细解读牛奶的营养价值，以及如何科学地饮用牛奶，让健康事半功倍。',
    content: `牛奶是人类最古老的天然饮品之一，被誉为"白色血液"。它富含优质蛋白质、钙、磷、维生素A、维生素D和维生素B2等多种营养素。每天饮用适量的牛奶，能够为身体提供全面的营养支持。

## 牛奶的核心营养价值

牛奶中的蛋白质含量约为3%，其中包括酪蛋白和乳清蛋白，都是优质完全蛋白，含有人体所需的全部必需氨基酸。钙质是牛奶最突出的营养成分，每100ml牛奶约含100-120mg钙，且钙磷比例适宜，易于人体吸收。

## 科学饮奶建议

中国居民膳食指南建议，成年人每天应摄入相当于液态奶300g的奶及奶制品。对于儿童、青少年、孕妇和老年人，可以适当增加摄入量。建议分次饮用，每次200-250ml为宜。

## 不同人群的饮奶选择

- **儿童**：选择添加DHA、钙铁锌的儿童配方牛奶，助力成长发育
- **青少年**：纯牛奶或高钙奶，满足骨骼快速生长需求
- **成年人**：根据自身需求选择纯牛奶、低脂或脱脂牛奶
- **老年人**：高钙奶或高钙高铁配方奶，预防骨质疏松

## 最佳饮用时间

早晨搭配早餐饮用，可以提供一上午的能量；晚上睡前半小时饮用，有助于睡眠和夜间钙质吸收。运动后30分钟内饮用，有助于肌肉恢复。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20being%20poured%20into%20glass%20on%20cream%20colored%20table%2C%20natural%20morning%20light%20streaming%20through%20window%2C%20minimalist%20food%20photography%2C%20warm%20gentle%20tones%2C%20editorial%20style%2C%20high%20quality%20lifestyle%20image%20with%20cozy%20vibe%20and%20soft%20atmosphere&width=1200&height=630&seq=article-01&orientation=landscape',
    category: '营养知识',
    author: '爱威奶营养团队',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['牛奶营养', '健康饮食', '科学饮奶'],
  },
  {
    slug: 'xia-ji-cu-xiao-huo-dong',
    title: '爱威奶夏日清凉季：全场满199减30，新品酸奶买二送一',
    excerpt: '炎炎夏日，爱威奶推出限时清凉优惠活动！全系列产品满199元立减30元，新品草莓酸奶买二送一，更有新人注册专享大礼包，多重好礼等你来拿。',
    content: `炎炎夏日，爱威奶为您带来超值清凉优惠！即日起至8月31日，多款明星产品参与限时促销活动。

## 活动一：全场满减

全系列产品（含纯牛奶、酸奶、儿童奶、高钙奶、低脂奶）消费满199元，立减30元。消费满399元，立减80元。无需领券，系统自动满减。

## 活动二：新品酸奶买二送一

爱威奶最新推出的草莓果粒酸奶和希腊式酸奶，活动期间购买任意两件，即赠送同款一件。让您尽情品尝新品，感受不一样的美味。

## 活动三：新人专享大礼包

首次注册爱威奶在线会员，即可获得价值50元的新人专享大礼包，包含满99减15优惠券一张、包邮券一张、以及新品体验装一份。

## 活动四：老客回馈

累计消费满500元的老客户，可在个人中心领取专属优惠券，享受全场9折优惠，不限使用次数。

## 配送说明

活动期间订单量较大，配送时效可能略有延迟。全国大部分地区支持次日达，偏远地区2-3天送达。全程冷链配送，确保产品新鲜度。

赶紧登录爱威奶在线，选购您喜爱的产品，享受夏日清凉优惠吧！`,
    coverImage: 'https://readdy.ai/api/search-image?query=Summer%20milk%20and%20yogurt%20products%20arranged%20beautifully%20with%20ice%20and%20fresh%20fruits%20on%20cream%20background%2C%20bright%20natural%20lighting%2C%20minimalist%20food%20photography%2C%20warm%20summer%20vibes%2C%20editorial%20style%2C%20high%20quality%20commercial%20shot&width=1200&height=630&seq=article-02&orientation=landscape',
    category: '优惠活动',
    author: '爱威奶市场部',
    date: '2026-08-01',
    readTime: '5分钟',
    tags: ['优惠活动', '夏日促销', '新品上市'],
  },
  {
    slug: 'ru-he-tiao-xuan-niu-nai',
    title: '如何挑选适合自己的牛奶？五种牛奶类型全解析',
    excerpt: '面对超市货架上琳琅满目的牛奶产品，你是否常常陷入选择困难？本文将为您详细对比纯牛奶、酸奶、儿童奶、高钙奶、低脂奶五大类型，助您找到最适合的那一款。',
    content: `走进超市的乳制品区，各种品牌、各种类型的牛奶让人眼花缭乱。今天，爱威奶营养团队为您详细解析五大主流牛奶类型，让选购不再困难。

## 纯牛奶：最天然的选择

纯牛奶是未经额外添加的天然牛奶，保留了牛奶最原始的营养成分和口感。适合大多数人群日常饮用。爱威奶纯牛奶采用巴氏杀菌工艺，既保证安全又最大限度保留营养。

## 酸奶：肠道健康的好帮手

酸奶是牛奶经过乳酸菌发酵制成，含有大量活性益生菌。经常饮用酸奶有助于维持肠道菌群平衡，促进消化吸收。对于乳糖不耐受的人群，酸奶是比纯牛奶更好的选择。

## 儿童牛奶：专为成长定制

儿童牛奶根据不同年龄段儿童的营养需求，额外添加了DHA、钙、铁、锌等营养元素。爱威奶儿童牛奶采用天然配方，不添加人工色素和防腐剂，妈妈可以放心选择。

## 高钙奶：强健骨骼的秘密武器

高钙奶在普通牛奶的基础上额外添加了钙质，钙含量比普通牛奶高出30%以上。特别适合中老年人、孕妇和青少年等需要补钙的人群。

## 低脂/脱脂牛奶：轻盈无负担

低脂牛奶的脂肪含量在1%-2%之间，脱脂牛奶的脂肪含量接近0。对于注重身材管理、有心血管健康顾虑的人群来说，低脂或脱脂牛奶是更佳的选择。

## 选购小贴士

1. 看配料表：配料越简单越天然
2. 看营养成分：重点关注蛋白质和钙含量
3. 看生产日期：选择日期较新的产品
4. 看包装：确保包装完好无破损`,
    coverImage: 'https://readdy.ai/api/search-image?query=Five%20different%20types%20of%20milk%20products%20lined%20up%20neatly%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20editorial%20style%2C%20clean%20composition%2C%20high%20quality%20comparison%20shot&width=1200&height=630&seq=article-03&orientation=landscape',
    category: '营养知识',
    author: '爱威奶营养团队',
    date: '2026-07-20',
    readTime: '10分钟',
    tags: ['牛奶选购', '营养科普', '产品对比'],
  },
  {
    slug: 'pin-pai-xin-wen-mu-chang',
    title: '爱威奶自有牧场再获国际认证，品质溯源更放心',
    excerpt: '爱威奶位于内蒙古天然牧场的自有养殖基地，近日通过了国际GAP（良好农业规范）认证。这标志着爱威奶在奶源品质管控方面再次获得国际权威认可。',
    content: `2026年7月，爱威奶位于内蒙古呼伦贝尔大草原的自有牧场，正式通过了国际GAP（良好农业规范）认证。这是继获得中国有机产品认证之后，爱威奶在品质管理方面取得的又一重要里程碑。

## 天然牧场，品质源头

爱威奶自有牧场位于北纬47°黄金奶源带，拥有得天独厚的自然条件。这里空气清新、水草丰美，全年日照充足，为奶牛提供了最适宜的生长环境。

## 科学养殖，全程可溯

牧场采用国际先进的智能化管理系统，每头奶牛都配有电子耳标，实现从饲养、挤奶到运输的全程可追溯。饲料采用自产有机牧草配以科学配方精饲料，确保奶牛营养均衡。

## 国际认证，品质保障

GAP认证是国际公认的农业生产规范标准，涵盖食品安全、环境保护、员工健康与福利、动物福利四大方面。通过此项认证，意味着爱威奶从源头到成品的每一个环节都符合国际最高标准。

## 透明公开，让消费者放心

为了让消费者更加放心，爱威奶在线平台开通了"品质溯源"功能。消费者只需扫描产品包装上的二维码，即可查看该批次产品的奶源产地、生产日期、检测报告等详细信息。

品质之路，永无止境。爱威奶将继续秉持"天然、健康、安全"的理念，为消费者提供更加优质的产品和服务。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20green%20pasture%20dairy%20farm%20with%20cows%20grazing%20under%20blue%20sky%2C%20cream%20warm%20natural%20lighting%2C%20minimalist%20landscape%20photography%2C%20peaceful%20rural%20scene%2C%20editorial%20style%2C%20high%20quality%2C%20clean%20composition&width=1200&height=630&seq=article-04&orientation=landscape',
    category: '品牌新闻',
    author: '爱威奶品牌部',
    date: '2026-07-15',
    readTime: '6分钟',
    tags: ['品牌新闻', '牧场认证', '品质溯源'],
  },
  {
    slug: 'niu-nai-pei-can-zhi-nan',
    title: '牛奶搭配指南：这些食物和牛奶一起吃营养翻倍',
    excerpt: '牛奶和什么食物搭配最有营养？哪些食物不宜与牛奶同食？本文将为您提供科学的牛奶搭配建议，让每一口都吃得健康又美味。',
    content: `牛奶是营养密度极高的食物，但如果搭配得当，营养价值还能更上一层楼。反之，不当的搭配则可能影响营养吸收。

## 最佳搭配推荐

**牛奶 + 燕麦**：经典早餐搭配。燕麦富含膳食纤维，牛奶提供优质蛋白和钙质，两者结合既饱腹又营养。

**牛奶 + 鸡蛋**：高蛋白组合。鸡蛋中的蛋白质与牛奶互补，提高蛋白质的利用率。

**牛奶 + 全麦面包**：碳水化合物与蛋白质的完美组合，提供持久能量。

**牛奶 + 坚果**：坚果富含不饱和脂肪酸和维生素E，与牛奶搭配，营养更全面。

**牛奶 + 香蕉**：运动后的完美恢复饮品。香蕉提供快速能量，牛奶帮助肌肉修复。

## 不宜搭配的食物

**牛奶 + 柑橘类水果**：酸性水果会使牛奶中的蛋白质凝固，影响消化。

**牛奶 + 巧克力**：可可中的草酸会与钙结合，降低钙的吸收率。

**牛奶 + 浓茶**：茶中的鞣酸会影响钙和蛋白质的吸收。

## 饮用温度建议

牛奶最佳饮用温度为40-50℃，过热会破坏营养成分，过冷会刺激肠胃。建议将冷藏牛奶取出后放置10-15分钟再饮用。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20breakfast%20table%20with%20milk%20glass%20oatmeal%20and%20fruits%20on%20cream%20background%2C%20natural%20morning%20light%2C%20minimalist%20food%20photography%2C%20warm%20cozy%20tones%2C%20editorial%20style%2C%20high%20quality%20lifestyle%20image&width=1200&height=630&seq=article-05&orientation=landscape',
    category: '营养知识',
    author: '爱威奶营养团队',
    date: '2026-07-10',
    readTime: '7分钟',
    tags: ['牛奶搭配', '营养知识', '健康饮食'],
  },
  {
    slug: 'xin-pin-shang-shi-tong-zhi',
    title: '爱威奶希腊式酸奶全新上市！三倍浓缩，醇厚如奶油',
    excerpt: '爱威奶重磅推出希腊式酸奶新品，采用传统希腊过滤工艺，三倍浓缩制作，每一杯都醇厚如奶油，蛋白质含量高达9g/100g，是健身人士和美食爱好者的新宠。',
    content: `经过长达一年的研发和测试，爱威奶希腊式酸奶于2026年7月正式上市！这款产品采用传统希腊过滤工艺，三倍牛奶浓缩制成，为您带来前所未有的醇厚口感。

## 什么是希腊式酸奶？

希腊式酸奶起源于地中海地区，与普通酸奶最大的区别在于制作工艺。它需要经过特殊的过滤步骤，去除大部分乳清，使得成品更加浓稠、蛋白质含量更高。

## 产品亮点

**三倍浓缩**：每150g希腊式酸奶由约450ml鲜牛奶浓缩而成，营养密度远超普通酸奶。

**超高蛋白**：蛋白质含量高达9g/100g，是普通酸奶的2-3倍，是健身增肌的理想选择。

**醇厚口感**：质地如奶油般细腻顺滑，可直接食用，也可替代奶油用于烘焙和烹饪。

**低乳糖**：过滤工艺去除了大部分乳清和乳糖，乳糖不耐受人群也可安心享用。

## 多种食用方式

- **直接食用**：搭配蜂蜜、坚果和水果
- **早餐伴侣**：涂抹在全麦面包上
- **烹饪食材**：替代奶油制作低脂酱料
- **运动补给**：健身后补充优质蛋白

新品上市期间，购买任意两杯即送同款一杯，限时优惠不要错过！`,
    coverImage: 'https://readdy.ai/api/search-image?query=Thick%20creamy%20Greek%20yogurt%20in%20elegant%20white%20bowl%20topped%20with%20honey%20and%20nuts%20on%20cream%20background%2C%20minimalist%20food%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20editorial%20style%2C%20high%20quality%2C%20appetizing%20composition&width=1200&height=630&seq=article-06&orientation=landscape',
    category: '品牌新闻',
    author: '爱威奶产品部',
    date: '2026-07-05',
    readTime: '4分钟',
    tags: ['新品上市', '希腊酸奶', '高蛋白'],
  },
];